











































import { Component, Prop, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

interface Node {
  term: string;
  children: Node[];
}

@Component({
  name: "term-tree"
})
export default class TermTree extends Vue {
  @Prop()
  private root!: Node;

  @Prop({ default: false })
  private bold!: boolean;

  @State("text")
  private text!: string;

  private extend: boolean = true;

  get included() {
    const lowercase = this.text && this.text.toLowerCase();

    return (
      lowercase &&
      (lowercase.includes(this.root.term.toLowerCase()) ||
        this.root.term
          .toLowerCase()
          .split(", ")
          .some(e => lowercase.includes(e)))
    );
  }
}
